import { Reveal, Overline, MagicImage } from "./primitives";

export const Story = () => (
  <section id="story" data-testid="story-section" className="bg-ivory py-28 md:py-40">
    <div className="mx-auto max-w-[1400px] px-6 md:px-10">

      {/* Chapter 01 — Why this exists */}
      <div className="grid items-center gap-12 lg:grid-cols-12 lg:gap-20">
        <Reveal className="order-2 lg:order-1 lg:col-span-6" y={50}>
          <MagicImage
            testid="story-image-childhood"
            src="/images/growing-up.jpg"
            alt="Growing up — the beginning of the story"
            glow="terracotta"
            speed={70}
            className="aspect-[4/5] w-full"
            imgClassName="rounded-[2px]"
          />
        </Reveal>

        <div className="order-1 lg:order-2 lg:col-span-6">
          <Reveal>
            <Overline>Story · Why This Exists</Overline>
          </Reveal>
          <Reveal delay={0.05}>
            <h2 className="mt-6 font-display text-4xl font-medium leading-[1.05] tracking-tight text-ink sm:text-5xl">
              I wasn't born into this. <span className="italic text-terracotta">I built it.</span>
            </h2>
          </Reveal>
          <Reveal delay={0.1}>
            <div className="mt-8 space-y-5 font-sans text-lg font-light leading-relaxed text-stonegray">
              <p>I grew up on welfare. Teen parents. No roadmap. No trust fund. No blueprint for building wealth.</p>
              <p>I became a graphic designer. Then a single mom. I worked incredibly hard.</p>
              <p className="text-ink">
                But hard work wasn't the problem. I simply didn't understand my own power yet.
              </p>
            </div>
          </Reveal>
        </div>
      </div>

      {/* Chapter 02 — What Changed */}
      <div className="mt-32 grid items-center gap-12 lg:mt-48 lg:grid-cols-12 lg:gap-20">
        <div className="lg:col-span-6">
          <Reveal>
            <Overline>What Changed</Overline>
          </Reveal>
          <Reveal delay={0.05}>
            <h2 className="mt-6 font-display text-4xl font-medium leading-[1.05] tracking-tight text-ink sm:text-5xl">
              My life didn't change because I became
              <span className="italic text-terracotta"> fearless.</span>
            </h2>
          </Reveal>
          <Reveal delay={0.1}>
            <div className="mt-8 space-y-5 font-sans text-lg font-light leading-relaxed text-stonegray">
              <p>It changed because I learned to see myself differently.</p>
              <p>I discovered what made me uniquely valuable. I caught the patterns that kept sabotaging me. I changed my relationship with money.</p>
              <p>I stopped waiting to feel confident and started taking courageous action anyway. Little by little… my life became bigger.</p>
              <p>I built Sash, a brand that went on to do more than <span className="text-ink">$30 million in sales.</span></p>
              <p className="font-display text-2xl italic leading-snug text-ink md:text-3xl">
                And I realized: I didn't have to become someone else. I had to become more myself.
              </p>
              <p className="text-ink">That's exactly what I want for you.</p>
            </div>
          </Reveal>
        </div>

        <Reveal className="lg:col-span-6" y={50}>
          <MagicImage
            testid="story-image-laughing"
            src="/images/laughing.jpg"
            alt="Learning to see myself differently"
            glow="sage"
            speed={70}
            className="aspect-[4/5] w-full"
            imgClassName="rounded-[2px]"
          />
        </Reveal>
      </div>
    </div>
  </section>
);
